import React, { useState, useRef, useEffect } from "react";

import { endPoints } from "../../../constant/Environment";
import { addData, getAllData, getAllFilterData } from "../../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import SearchIcon from "@mui/icons-material/Search";
import { Col, Row, Container } from "react-bootstrap";
import EditIcon from "@mui/icons-material/Edit";
import successicon from "../../../assests/payments_icon/success.png";
import pendingicon from "../../../assests/payments_icon/pending.png";
import canceicon from "../../../assests/payments_icon/cancel.png";
import RedemDetails from "./redemDetails";
import { Tab, Tabs } from "@mui/material";
import CashWithDrawal from "./cashWithDrawal";
import CardWithDrawal from "./cardWithDrawal";
import CryptoWithDrawal from "./cryptoWithDrawal";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </Box>
  );
}

const RedemptionClaims = () => {
  const [editData, setEditData] = useState({});

  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [page, setPage] = React.useState(1);
  const [totalcount, setTotalCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [userId, setUserId] = useState("");
  const [statusType, setStatusType] = useState("");

  const [email, setEmail] = useState("");
  const [username, setuserName] = useState("");
  const [name, setName] = useState("");

  const [detailsModal, setDetailModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});

  const [value, setValue] = React.useState("one");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
    redemptionClaimList(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
  };

  let filterData = {
    userName: username,
    email: email,
    fromDate: "",
    toDate: "",
    sort: "",
    userId: userId,
    status: statusType,
  };
  useEffect(() => {
    // api call
    redemptionClaimList(1);
  }, []);

  useEffect(() => {
    redemptionClaimList(page);
  }, [rowsPerPage]);

  const redemptionClaimList = async (page) => {
    let url = `${endPoints.api.GET_REDEMPTIONCLAIM}/${page}/${rowsPerPage}`;
    setIsLoading(true);
    await getAllFilterData(url, filterData)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          let data = response.data;
          setRows(response.data);

          const ITEMS_PER_PAGE = rowsPerPage;
          setTotalCount(data[0]?.totalCount);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      redemptionClaimList(page);
    }
  };

  const StatusTypeList = [
    {
      id: 1,
      name: "Pending",
    },
    {
      id: 2,
      name: "Processed",
    },
    {
      id: 3,
      name: "Canceled",
    },
  ];

  const PendingCsv = () => {
    setIsLoading(true);
    fetch(`${endPoints.apiBaseUrl + `giftstransaction/download/1/csv`}`, {
      method: "GET",
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(function (response) {
      setIsLoading(false);
      response.blob().then((blob) => {
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = "PendingResult.csv";
        link.click();
      });
    });
  };
  const ProcessedCsv = () => {
    setIsLoading(true);
    fetch(`${endPoints.apiBaseUrl + `giftstransaction/download/2/csv`}`, {
      method: "GET",
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(function (response) {
      setIsLoading(false);
      response.blob().then((blob) => {
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = "ProcessedResult.csv";
        link.click();
      });
    });
  };
  const CanceledCsv = () => {
    setIsLoading(true);
    fetch(`${endPoints.apiBaseUrl + `giftstransaction/download/3/csv`}`, {
      method: "GET",
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(function (response) {
      setIsLoading(false);
      response.blob().then((blob) => {
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = "CanceledResult.csv";
        link.click();
      });
    });
  };

  const redemptionClaimById = async (item, type) => {
    const SINGLE_GIFT_REDEMPTIONCLAIM = "api/casino/gifttransaction";
    let url = `${SINGLE_GIFT_REDEMPTIONCLAIM}/${item.id}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setEditData(response.data);
          // type == "view" && setViewShow(true);
          // type == "approve" && setCheckShow(true);
          // type == "cancel" && setCancelShow(true);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  return (
    <>
      <div className="main">
        <Toaster></Toaster>

        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2 heading-table"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                    Redemption Claims
                  </h3>
                </div>
              </div>

              <Tabs
                value={value}
                onChange={handleChange}
                textColor="secondary"
                indicatorColor="secondary"
                aria-label="secondary tabs example"
              >
                <Tab value="one" label="Gift Card" />
                {/* <Tab value="two" label="Cash" />
                <Tab value="three" label="Card" /> */}
                <Tab value="Four" label="Crypto" />
                
              </Tabs>
              {value === "one" && (
                <div style={{}}>
                  <Row>
                    <Col>
                      <Form.Group as={Col} controlId="formAccount">
                        <Form.Label className="label">Status</Form.Label>
                        <Form.Select
                          name="platform"
                          value={statusType}
                          onChange={(e) => {
                            setStatusType(e.target.value);
                          }}
                        >
                          <option value="">Select Status</option>
                          {StatusTypeList.map((item) => {
                            return <option value={item.id}>{item.name}</option>;
                          })}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group as={Col} controlId="formName">
                        <Form.Label className="label">Customer ID</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Enter Customer ID"
                          value={userId}
                          onChange={(e) => setUserId(e.target.value)}
                          onKeyDown={handleKeyDown}
                        />
                      </Form.Group>
                    </Col>

                    <Col>
                      <Form.Group as={Col} controlId="formName">
                        <Form.Label className="label">Email</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Enter Email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          onKeyDown={handleKeyDown}
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group
                        as={Col}
                        controlId="formName"
                        style={{ marginTop: "30px" }}
                      >
                        <Button
                          variant="primary"
                          style={{
                            width: "70%",
                            background: "#0D3862",
                            borderRadius: "8px",
                          }}
                          onClick={() => {
                            redemptionClaimList(1);
                          }}
                        >
                          Search
                        </Button>
                      </Form.Group>
                    </Col>
                  </Row>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      marginBottom: "20px",
                    }}
                  >
                    <Button
                      onClick={() => {
                        PendingCsv();
                      }}
                      variant="primary"
                    >
                      Pending Download
                    </Button>

                    <Button
                      onClick={() => {
                        ProcessedCsv();
                      }}
                      variant="primary"
                      style={{ marginLeft: "10px" }}
                    >
                      Processed Download
                    </Button>

                    <Button
                      onClick={() => {
                        CanceledCsv();
                      }}
                      variant="primary"
                      style={{ marginLeft: "10px" }}
                    >
                      Canceled Download
                    </Button>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <TableContainer component={Paper}>
                        <Table
                          className="c_table"
                          size="small"
                          aria-label="a dense table"
                          stickyHeader
                          sx={{ minWidth: 500 }}
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell align="center">Customer ID</TableCell>
                              {/* <TableCell align="center">Gift Title</TableCell> */}
                              <TableCell align="center">Name </TableCell>
                              <TableCell align="center">Email </TableCell>
                              <TableCell align="center">VIP Label </TableCell>

                              <TableCell align="center">
                                 Deposit
                              </TableCell>
                              <TableCell align="center">
                                 Settled
                              </TableCell>
                              <TableCell align="center"> Redeem</TableCell>
                              <TableCell align="center"> WithDrawal</TableCell>
                              <TableCell align="center">
                                Account Status{" "}
                              </TableCell>
                              <TableCell align="center">
                                Request Date{" "}
                              </TableCell>
                              <TableCell align="center">
                                Processed Date
                              </TableCell>
                              <TableCell align="center">
                                Total Pending Redeem
                              </TableCell>
                              <TableCell align="center">
                                Pending Count
                              </TableCell>
                              <TableCell align="center">Options</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map((row) => (
                              <TableRow
                                key={row.id}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                                    style={{
                              background : row.totalDeposit?.toFixed(2) === row.totalSetlledDeposit?.toFixed(2)  ? 'white' : '#f27c7c'
                              }}
                              >
                                <TableCell align="center">
                                  {row.user_id}
                                </TableCell>
                                {/* <TableCell align="center">
                                {row.gift_title}
                              </TableCell> */}
                                <TableCell align="center">{row.name}</TableCell>
                                <TableCell align="center">
                                  {row.email}
                                </TableCell>
                                <TableCell align="center">{row.vipLavel}</TableCell>
                                <TableCell align="center">
                                  ${row?.totalDeposit?.toFixed(2)}
                                </TableCell>
                                   <TableCell align="center">
                                  ${row.totalSetlledDeposit?.toFixed(2)}
                                </TableCell>
                                <TableCell align="center">
                                  ${row?.totalRedeem?.toFixed(2)}
                                </TableCell>
                                <TableCell align="center">
                                  ${row?.totalWidhdrawl?.toFixed(2)}
                                </TableCell>
                                
                                <TableCell align="center">
                                  {row.accountStatus}
                                </TableCell>
                                <TableCell align="center">
                                  {row.created_on
                                    ? moment.utc(row.created_on).isValid()
                                      ? moment
                                          .utc(row.created_on)
                                          .format("YYYY-MM-DD")
                                      : ""
                                    : ""}
                                </TableCell>

                                <TableCell align="center">
                                  {row.processed_date
                                    ? moment.utc(row.processed_date).isValid()
                                      ? moment
                                          .utc(row.processed_date)
                                          .format("YYYY-MM-DD")
                                      : ""
                                    : ""}
                                </TableCell>
                                <TableCell align="center">
                                  {row?.totalPendingRedeem ?  `$${row.totalPendingRedeem}`  :''} 
                                </TableCell>
                                <TableCell align="center">
                                  {row.pendingCount}
                                </TableCell>

                                <TableCell
                                  align="center"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-evenly",
                                  }}
                                >
                                  <Button
                                    variant="primary"
                                    className="mrglft10"
                                    style={{
                                      background: "#0D3862",
                                      borderRadius: "8px",
                                      fontSize: "9px",
                                      fontWeight: "bold",
                                    }}
                                    onClick={() => {
                                      // window.open("http://localhost:3000/redemption-details/3500", "_blank");
                                      // navigate("/redemption-details", { state: { user_id: row.user_id } });
                                      setDetailModal(true);
                                      setSelectedRecord(row);
                                    }}
                                  >
                                    More Redeem
                                  </Button>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                          <TableFooter>
                            <TableRow>
                              <TablePagination
                                className="hide-rows-per-page-options"
                                rowsPerPageOptions={[
                                  5, 10, 25, 50, 100, 200, 500,
                                ]}
                                colSpan={12}
                                count={
                                  rowsPerPage === -1 ? rows.length : totalcount
                                }
                                rowsPerPage={rowsPerPage}
                                page={page - 1}
                                SelectProps={{
                                  inputProps: {
                                    "aria-label": "rows per page",
                                  },
                                  native: true,
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActions}
                              />
                            </TableRow>
                          </TableFooter>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>
                </div>
              )}
                 {/* {value === "two" && <div >cash tab</div>} */}
              {/* {value === "two" && <CashWithDrawal />} */}
              {/* {value ==="three" && <CardWithDrawal/> } */}
                {
                value ==="Four" && <CryptoWithDrawal/> }
              
            </div>
          </div>
        </div>

        <Modal
          show={detailsModal}
          onHide={() => {
            setDetailModal(false);
          }}
          fullscreen
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Redemption Claims Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <RedemDetails selectedRecord={selectedRecord} />
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default RedemptionClaims;
